import React from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaUserPlus, 
    FaSyncAlt, 
    FaUsers,
    FaArrowRight,
    FaFileAlt,
    FaLayerGroup
} from 'react-icons/fa';

const EngineerAllUsers = () => {
    const navigate = useNavigate();

    const ActionCard = ({ title, subtitle, icon, onClick, colorClass, iconColor }) => (
        <div 
            onClick={onClick}
            className="group cursor-pointer bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col items-start overflow-hidden h-full"
        >
            <div className={`h-1.5 w-full ${colorClass}`}></div>
            <div className="p-8 flex flex-col items-start space-y-6 flex-grow">
                <div className={`p-4 rounded-xl ${iconColor} bg-opacity-10 transition-transform duration-500 group-hover:scale-110 shadow-sm`}>
                    <div className={`text-3xl ${iconColor.replace('bg-', 'text-')}`}>
                        {icon}
                    </div>
                </div>
                <div>
                    <h3 className="text-xl font-bold text-gray-800 tracking-tight mb-2">
                        {title}
                    </h3>
                    <p className="text-gray-400 text-sm font-bold">
                        {subtitle}
                    </p>
                </div>
            </div>
            <div className="w-full h-12 px-8 flex items-center justify-between border-t border-gray-50 bg-gray-50/30 group-hover:bg-gray-50 transition-colors">
                <span className="text-gray-400 text-xs font-bold uppercase tracking-widest">निवडा</span>
                <FaArrowRight className="text-gray-300 group-hover:text-gray-600 transition-colors" size={14} />
            </div>
        </div>
    );

    return (
        <EngineerLayout>
            <div className="p-6 md:p-8 bg-gray-50/30 min-h-screen">
                {/* Dark Header Card */}
                <div className="bg-[#1a1c23] rounded-3xl p-10 mb-12 shadow-2xl relative overflow-hidden group">
                    <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32 blur-3xl transition-transform duration-1000 group-hover:scale-110"></div>
                    <div className="absolute bottom-0 left-0 w-32 h-32 bg-blue-500/10 rounded-full -ml-16 -mb-16 blur-2xl"></div>
                    
                    <div className="relative flex flex-col md:flex-row justify-between items-center gap-6">
                        <div>
                            <h1 className="text-4xl font-bold text-white tracking-tight mb-3">अर्ज (Applications)</h1>
                            <p className="text-gray-400 font-bold text-sm tracking-widest uppercase">
                                अर्ज निवडण्यासाठी खालील पर्यायांवर क्लिक करा
                            </p>
                        </div>
                        <button 
                            onClick={() => navigate('/engineer-dashboard')}
                            className="bg-[#2d2f39] hover:bg-[#383a45] text-white px-8 py-3 rounded-xl text-sm font-bold tracking-widest transition-all hover:scale-105 active:scale-95 shadow-lg"
                        >
                            मागे जा
                        </button>
                    </div>
                </div>

                {/* Cards Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-[1200px] mx-auto">
                    <ActionCard 
                        title="नवीन सु.भे. अभियंता" 
                        subtitle="नवीन अभियंता नोंदणी फॉर्म"
                        icon={<FaUserPlus />} 
                        onClick={() => navigate('/engineer/engineers')}
                        colorClass="bg-[#0ea5e9]"
                        iconColor="bg-[#0ea5e9]"
                    />
                    <ActionCard 
                        title="नूतनीकरण सु.भे. अभियंता" 
                        subtitle="नूतनीकरण वापरकर्ते फॉर्म"
                        icon={<FaSyncAlt />} 
                        onClick={() => navigate('/engineer/engineers/old')}
                        colorClass="bg-[#10b981]"
                        iconColor="bg-[#10b981]"
                    />
                    <ActionCard 
                        title="नवीन मजूर सहकारी संस्था" 
                        subtitle="सोसायटी नवीन वापरकर्ते फॉर्म"
                        icon={<FaUsers />} 
                        onClick={() => navigate('/engineer/societies')}
                        colorClass="bg-[#f59e0b]"
                        iconColor="bg-[#f59e0b]"
                    />
                    <ActionCard 
                        title="लिमिट एक्सपांड" 
                        subtitle="मर्यादा विस्तृत करा (Extend Limit)"
                        icon={<FaLayerGroup />} 
                        onClick={() => navigate('/engineer/extend-limit')}
                        colorClass="bg-[#8b5cf6]"
                        iconColor="bg-[#8b5cf6]"
                    />
                </div>
            </div>
        </EngineerLayout>
    );
};

export default EngineerAllUsers;
